import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { H2 } from "components/core/Typography";
import SearchBar from "components/search/SearchBar/SearchBar";

import "./StickySearchHeader.scss";

function StickySearchHeader({ title, buttonText, id, label, triggerId }) {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		let cleanup;

		if (triggerId) {
			const triggerElement = document.getElementById(triggerId);
			if (triggerElement) {
				const observer = new IntersectionObserver(
					([entry]) => {
						// Show sticky header when trigger element is NOT in view
						setIsVisible(!entry.isIntersecting);
					},
					{ threshold: 0 }
				);

				observer.observe(triggerElement);

				cleanup = () => {
					observer.unobserve(triggerElement);
					observer.disconnect();
				};
			}
		}

		return cleanup;
	}, [triggerId]);
	
	return (
		<section className="sticky-search-header-container" data-visible={isVisible}>
			<SearchBar
				buttonText={buttonText}
				id={id}
				label={label}
				theme="stickyDarkBlue"
				className="sticky-search-header"
				buttonClassName="sticky-search-header-button"
			>
				<H2
					weight="bold"
					size="xlarge"
					largeSize="large"
					align="center"
					color="white"
				>
					{title}
				</H2>
			</SearchBar>
		</section>
	);
}

StickySearchHeader.propTypes = {
	title: PropTypes.string,
	buttonText: PropTypes.string,
	id: PropTypes.string,
	label: PropTypes.string,
	triggerId: PropTypes.string
};

StickySearchHeader.defaultProps = {
	title: "Find Cheap Storage Units Near You",
	buttonText: "Find Storage",
	id: "sticky-search-bar",
	label: "Search by zip..."
};

export default StickySearchHeader;
